<template>
  <div>
    <div style="color: #194cc3; cursor: pointer" @click="isModalOpen = true">
      {{ subject }}
    </div>
    <div
      class="review-picture-wrap"
      v-if="isModalOpen"
      @click.self="isModalOpen = false"
    >
      <div class="review-picture-modal">
        <!-- head -->
        <h3 class="form-item py-5">{{ subject }}</h3>
        <!-- body -->
        <div class="pa-5">
          <div
            class="w-100 bg-cover bg-center"
            :style="{ backgroundImage: `url(${image})`, paddingTop: '100%' }"
          ></div>
        </div>
        <!-- foot -->
        <div class="pa-5 d-flex">
          <button class="btn ml-auto" @click="closeHandler">關閉</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    isModalOpen: false,
    subject: 'Shop ADATA special: subject wowo XENIA+PRECOG Combo!',
    image: 'https://dummyimage.com/1000x1000.jpg',
  }),
  methods: {
    closeHandler() {
      this.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.review-picture {
  &-wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(160, 160, 160, 0.5);
    z-index: 5;
  }
  &-modal {
    width: 720px;
    height: 668px;
    overflow: auto;
    margin: 0 auto;
    margin-top: 40px;
    background-color: #fff;
    border-radius: 4px;
  }
}
</style>
